import { render, staticRenderFns } from "./ProductOrderNew.vue?vue&type=template&id=59eef3df&scoped=true&"
import script from "./ProductOrderNew.vue?vue&type=script&lang=js&"
export * from "./ProductOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderNew.vue?vue&type=style&index=0&id=59eef3df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eef3df",
  null
  
)

export default component.exports